module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"day":"Day","status":"Status","started":"Started","refresh":"Refresh","finished":"Finished"},"et":{"day":"Day","status":"Status","started":"Started","refresh":"Refresh","finished":"Finished"},"ru":{"day":"Day","status":"Status","started":"Started","refresh":"Refresh","finished":"Finished"}}')
  delete Component.options._Ctor
}
